import React from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    Button,
    Box,
    Typography,
    Alert,
} from '@mui/material';
import {
    Input,
    DateInput,
    WeightInput,
    Select,
    CommonModal,
} from '../index';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import { trakrefFontFamily } from '../../../utils';
import { cylinderReweighReasons } from './utils';
import { Translate } from '../../../Utils/Languages/Translate';
import UserInfo from '../../../UserInfo';

const ReweighModal = ({
    open,
    header,
    onSubmit,
    closeModal,
    state,
    setReweighState,
    reweighModalButtonDisabled,
    inventoryDetailsPage,
}) => {
    const commonReweighError = (
        (!inventoryDetailsPage && state.reweigh.newGasWeightLbs && (state.reweigh.newGasWeightLbs > state.selectedCylinder.maxGasCapacityLbs))
        || (inventoryDetailsPage && state.newGasWeightLbs && (state.newGasWeightLbs > state.maxGasCapacity))
    );
    return (
        <CommonModal 
            open={open}
            close={() => {
                closeModal(false);
            }}
            header={header}
            bottom={24}
            scroll="paper"
            paperSx={{ margin: { xs: 0, sm: '32px' }, width: { xs: '450px', md: '450px', lg: '100%' } }}
        >
            <Grid container spacing={2} sx={{ marginTop: '1%', padding: '0% 8%', mb: {xs: 2} }}>
                <Grid item xs={12} sx={{ marginBottom: '6%' }}>
                    <DateInput
                        required
                        allowPast
                        label="Date of Reweigh*"
                        variant="standard"
                        date={inventoryDetailsPage ? state.reweighDate : state.reweigh.reweighDate}
                        onChange={new_date => setReweighState({ reweighDate: new_date })}
                    />
                </Grid>
                <WeightInput
                    required
                    showConversionArrows
                    removePadding
                    header="New Gas Weight"
                    variant="standard"
                    columnSpan={5}
                    value={inventoryDetailsPage ? state.newGasWeightLbs : state.reweigh.newGasWeightLbs}
                    onChange={new_weight => setReweighState({ newGasWeightLbs: new_weight })}
                />
                <Grid item xs={12}>                      
                    <Select
                        required
                        value={inventoryDetailsPage ? state.reasonId : state.reweigh.reasonId}
                        onChange={e => setReweighState({ reasonId: e.target.value})}
                        label='Reason'
                        variant='standard'
                        options={cylinderReweighReasons}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Input
                        fullWidth
                        value={inventoryDetailsPage ? state.notes : state.reweigh.notes}
                        onChange={e => setReweighState({ notes: e.target.value })}
                        label="Notes"
                        maxCharacterLength={50}
                    />
                </Grid>
                {!!commonReweighError && (
                    <Grid item xs={12}>
                        <Alert severity="error">
                            {Translate(
                                "ReweighAmountLimit",
                                {
                                    maxCapacity: inventoryDetailsPage ? state.maxGasCapacity : state.selectedCylinder.maxGasCapacityLbs,
                                    weightUnits: UserInfo.getWeightUnits()
                                })}
                        </Alert>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            disabled={reweighModalButtonDisabled || commonReweighError}
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={onSubmit}
                            style={{
                                backgroundColor: (reweighModalButtonDisabled || commonReweighError) ? trakrefDisabledBlue : trakrefBlue
                            }}
                        >
                            <Typography
                                variant='h5'
                                sx={{
                                    padding: '1% 0%',
                                    color: '#fff',
                                    fontSize: '16px',
                                    fontFamily: trakrefFontFamily
                                }}
                            >
                                Reweigh Cylinder
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </CommonModal>
    );
};

ReweighModal.propTypes = {
    open: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    state: PropTypes.object.isRequired,
    setReweighState: PropTypes.func.isRequired,
    reweighModalButtonDisabled: PropTypes.bool.isRequired,
    inventoryDetailsPage: PropTypes.bool,
};

ReweighModal.defaultProps = {
    inventoryDetailsPage: false
};

export default ReweighModal;
